"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var SelectButtonGrid_1 = __importDefault(require("atomicComponents/organisms/Button/SelectButtonGrid"));
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalAlertIcon_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalAlertContext/ModalAlertIcon"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var constants_1 = require("containers/AssistedOnboarding/WelcomeFlow/constants");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var BackdropLoader_1 = __importDefault(require("shared/components/Loaders/BackdropLoader"));
var Text_1 = __importDefault(require("shared/components/Text"));
var analytics_1 = require("utils/analytics");
var backend_1 = require("utils/backend");
var general_1 = require("utils/general");
var logging_1 = require("utils/logging");
var single_1 = require("utils/selectors/single");
var UnsupportedIntegration_1 = __importDefault(require("./UnsupportedIntegration"));
var utils_1 = require("./utils");
var PLATFORM_CONSTANTS_ACCOUNTING = {
    platformsLogo: constants_1.ACC_PLATFORMS_LOGO,
    platformsModal: interfaces_1.ACC_PLATFORMS_MODAL,
    platformsMapper: end2end_1.ACCOUNTING_PLATFORMS_MAPPER,
};
var PLATFORM_CONSTANTS_PRACTICE_MANAGER = {
    platformsLogo: constants_1.PRACTICE_MANAGER_PLATFORMS_LOGO,
    platformsModal: interfaces_1.PRACTICE_MANAGER_PLATFORMS_MODAL,
    platformsMapper: end2end_1.PRACTICE_MANAGER_PLATFORMS_MAPPER,
};
var AddConnectionModal = function (_a) {
    var props = __rest(_a, []);
    var isPracticeManagement = (0, react_router_1.useRouteMatch)('/settings/integrations/practice-management');
    var _b = isPracticeManagement
        ? PLATFORM_CONSTANTS_PRACTICE_MANAGER
        : PLATFORM_CONSTANTS_ACCOUNTING, platformsLogo = _b.platformsLogo, platformsModal = _b.platformsModal, platformsMapper = _b.platformsMapper;
    var options = (0, general_1.makeValueLabelArray)(platformsModal, platformsMapper).map(function (option) {
        var _a, _b;
        return (__assign(__assign({}, option), { logo: (_a = platformsLogo[option.value]) === null || _a === void 0 ? void 0 : _a.logo, icon: (_b = platformsLogo[option.value]) === null || _b === void 0 ? void 0 : _b.icon }));
    });
    var userHasMfa = (0, react_redux_1.useSelector)(single_1.selectUserHas2fa);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var _c = __read(react_1.default.useState(), 2), accountingSystem = _c[0], setAccountingSystem = _c[1];
    var pathname = (0, react_router_1.useLocation)().pathname;
    var unSupportedPlatform = accountingSystem && !(0, interfaces_1.isSupportedAccPlatform)(accountingSystem, !!isPracticeManagement);
    var trackSelect = (0, analytics_1.usePreparedTracker)('Accounting Provider Selected', { context: 'New Connection Modal' });
    var _d = __read((0, backend_1.useCall)('transactions-getAccConnection', {
        companyId: company.id,
        purpose: end2end_1.IS_RECHARGLY
            ? (isPracticeManagement ? 'RECHRGLY_XPM' : 'RECHRGLY')
            : undefined,
    }), 2), getAccConnection = _d[0], isSending = _d[1];
    var connect = function (provider) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, utils_1.connectAccountingSystem)(getAccConnection, "".concat(pathname, "?provider=").concat(provider), provider)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    (0, logging_1.logError)(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClick = function (provider) {
        setAccountingSystem(provider);
        var isSupported = (0, interfaces_1.isSupportedAccPlatform)(provider, !!isPracticeManagement);
        trackSelect({ isSupported: isSupported, provider: provider });
        if (isSupported && (userHasMfa || !end2end_1.IS_RECHARGLY)) {
            connect(provider);
        }
    };
    if (accountingSystem && !userHasMfa && !unSupportedPlatform) {
        return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({ label: "Multi-factor authentication required" }, props, { maxWidth: "sm" }, { children: [(0, jsx_runtime_1.jsxs)(ModalContent_1.default, __assign({ textAlign: "center" }, { children: [(0, jsx_runtime_1.jsx)(ModalAlertIcon_1.default, { status: "success", icon: "/ShieldCheck.svg" }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, pt: 2 }, { children: "Multi-factor authentication required" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone", pt: 2 }, { children: "Before connecting to Xero, you need to enable multi-factor authentication to ensure the security of your account." }))] })), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "inline-flex", alignItems: "center", justifyContent: "flex-end", gap: 2 }, { children: [(0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ onClick: function () { return setAccountingSystem(undefined); }, color: "neutral" }, { children: "Go back" })), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ url: "/settings/my-account" }, { children: "Enable multi-factor authentication" }))] })) })] })));
    }
    return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({}, props, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3 }, { children: ["Add new ", isPracticeManagement ? 'practice management' : 'accounting', " system"] })) }), (0, jsx_runtime_1.jsxs)(ModalContent_1.default, { children: [isSending && ((0, jsx_runtime_1.jsx)(BackdropLoader_1.default, { msg: "We're syncing to ".concat(accountingSystem ? (0, end2end_1.getProviderAsNice)(accountingSystem) : 'this', ".\n                  It'll be a few seconds. Sit tight.") })), !accountingSystem && ((0, jsx_runtime_1.jsx)(SelectButtonGrid_1.default, { options: options, isSending: isSending, handleClick: handleClick, selectedValue: accountingSystem })), unSupportedPlatform && ((0, jsx_runtime_1.jsx)(UnsupportedIntegration_1.default, { provider: (0, end2end_1.getProviderAsNice)(accountingSystem) || 'this', handleGoBack: function () { return setAccountingSystem(undefined); } }))] })] })));
};
exports.default = AddConnectionModal;
